import { TenantLogo as TenantLogo_filmzi } from './TenantLogo.filmzi';
import { TenantLogo as TenantLogo_kojaro } from './TenantLogo.kojaro';
import { TenantLogo as TenantLogo_pedal } from './TenantLogo.pedal';
import { TenantLogo as TenantLogo_zoomg } from './TenantLogo.zoomg';
import { TenantLogo as TenantLogo_zoomit } from './TenantLogo.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'filmzi':
      return TenantLogo_filmzi;

    case 'pedal':
      return TenantLogo_pedal;

    case 'zoomg':
      return TenantLogo_zoomg;

    case 'kojaro':
      return TenantLogo_kojaro;

    default:
      return TenantLogo_zoomit;
  }
};

export const TenantLogo = IconRenderer();
